import { APIEndpoint, EndpointType, httpPostNoAuth } from './apiService'

const apiURL = APIEndpoint(EndpointType.ErrorLog) + "/info";

// Records each Mapbox map load so we can trace where map loads are coming from.
// Uses the no-auth POST because the public storefront map is shown to anonymous visitors.
// sourceIpAddress is left blank; the backend fills it in from the API Gateway request.
export const logMapLoad = (mapName: string, description = "MapBox loaded successfully") => {
    const logRequest = {
        type: "custom_log_request",
        sourceIpAddress: "",
        info: {
            userAgent: navigator.userAgent,
            description: description,
            timestamp: new Date().toISOString().replace(/\.\d{3}Z$/, "Z"),
            map: mapName,
            url: window.location.href,
            referrer: document.referrer
        }
    }

    httpPostNoAuth(apiURL, JSON.stringify(logRequest))
        .catch((error) => console.log("Map load log failed: ", error))
}
